import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const CardContent = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',

  [theme.breakpoints.up('lg')]: {
    padding: `${theme.spacing(2)} ${theme.spacing(10)}`,
  },
}));
